/*!
 * @Author: pwy
 * @Date: 2025-05-07
 * @Last Modified by: pwy
 * @Last Modified time: 2025-05-07
 * @Instruduction: 媒体标签服务接口
 */

import xhr from './xhr/index'

interface IGetMediaTagsRelationParams {
    medium_id: number   // 媒体ID
}

interface IAddMediaTagsRelationParams {
    medium_id: number   // 媒体ID
    tag_ids: number[]   // 标签ID列表
}

interface IRemoveMediaTagRelationParams {
    medium_id: number   // 媒体ID
    tag_id: number      // 标签ID
}

interface ISearchMediaTagsParams {
    keyword?: string    // 搜索关键词
}

class MediaTagService {
    /** 获取媒体的所有标签 */
    public getMediaTagRelation(params: IGetMediaTagsRelationParams) {
        return xhr({
            method: 'get',
            url: '/media/media_tag_relation',
            params: params
        })
    }

    /** 给媒体添加标签（先删除所有现有标签，再添加新标签） */
    public addMediaTagRelation(params: IAddMediaTagsRelationParams) {
        return xhr({
            method: 'post',
            url: '/media/media_tag_relation',
            params: params
        })
    }

    /** 移除媒体的标签 */
    public removeMediaTagRelation(params: IRemoveMediaTagRelationParams) {
        return xhr({
            method: 'delete',
            url: '/media/media_tag_relation',
            params: params
        })
    }

    /** 模糊搜索媒体标签 */
    public mediaTagSearch(params: ISearchMediaTagsParams) {
        return xhr({
            method: 'get',
            url: '/media/media_tag_search',
            params: params
        })
    }

    /** 获取标签详情 */
    public getTag(params: { id: number }) {
        return xhr({
            method: 'get',
            url: '/media/tag',
            params: params
        })
    }

    /** 创建新标签 */
    public createTag(params: { name: string }) {
        return xhr({
            method: 'post',
            url: '/media/tag',
            params: params
        })
    }

    /** 更新标签 */
    public updateTag(params: { id: number, name: string }) {
        return xhr({
            method: 'put',
            url: '/media/tag',
            params: params
        })
    }

    /** 删除标签 */
    public deleteTag(params: { id: number }) {
        return xhr({
            method: 'delete',
            url: '/media/tag',
            params: params
        })
    }


}

// 实例化后导出，全局单例
export default new MediaTagService()